document.querySelectorAll('.ritual-problem').forEach((section) => {
  const revealEls = section.querySelectorAll('[data-reveal], [data-reveal-stagger]');

  if (!revealEls.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  revealEls.forEach((el) => observer.observe(el));
});
